import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function RouteGuard({ module, write = false, admin = false, anyWriteModules, children }) {
  const { user, loading, can, canWrite, isSuperAdmin, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-[var(--text-muted)] text-[13px]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (admin) {
    if (!isSuperAdmin && !isAdmin) {
      return <AccessDenied message="Admin access required." />;
    }
    return children;
  }
  if (anyWriteModules?.length) {
    const allowed = anyWriteModules.some((m) => canWrite(m));
    if (!allowed) {
      return <AccessDenied message="You do not have access to this area." />;
    }
    return children;
  }
  const allowed = write ? canWrite(module) : can(module);
  if (!allowed) {
    return <AccessDenied message="You do not have access to this area." />;
  }
  return children;
}

function AccessDenied({ message }) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center px-6 text-center" data-testid="access-denied">
      <div className="font-display text-2xl text-[#07539A]">Access restricted</div>
      <p className="text-[13px] text-[var(--text-muted)] mt-2 max-w-md">{message}</p>
    </div>
  );
}
